import { formatCurrencyForDisplay } from '@utils'
import { useCurrencies } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'

import './ExchangeRate.scss'

interface ExchangeRateProps {
  rate: number
  sourceCurrencyCode: string
  targetCurrencyCode: string
}

export const ExchangeRate = ({ rate, sourceCurrencyCode, targetCurrencyCode }: ExchangeRateProps) => {
  const { formatFxRate } = useCurrencies()

  return (
    <div className='exchange-rate'>
      <span className='exchange-rate-label'>{tr('FRONTEND.EXCHANGE.RATE', 'Rate')}:</span>
      <span className='exchange-rate-content'>
        {`1 ${formatCurrencyForDisplay(sourceCurrencyCode)} = ${formatFxRate(rate, targetCurrencyCode)} ${formatCurrencyForDisplay(targetCurrencyCode)}`}
      </span>
    </div>
  )
}
